import { render, staticRenderFns } from "./CustomDemandsManage.vue?vue&type=template&id=1bc15f25&scoped=true"
import script from "./CustomDemandsManage.vue?vue&type=script&lang=js"
export * from "./CustomDemandsManage.vue?vue&type=script&lang=js"
import style0 from "./CustomDemandsManage.vue?vue&type=style&index=0&id=1bc15f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc15f25",
  null
  
)

export default component.exports